module.exports = __webpack_public_path__ + "static/media/communication coordinatorG icon.2fd9d555.svg";